import React from 'react';
import { ArrowRight } from 'react-feather';
import { CALENDAR_LINK } from '../../constants/demo-link';
import styled from '../../styled';
import { COLORS } from '../../themes/color';
import { Headline } from '../Headline';

const SectionWrapper = styled('section')`
  padding: 60px 24px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 960px) {
    padding: 80px 24px;
  }
`;

const SectionHeader = styled('div')`
  text-align: center;
  margin-bottom: 60px;

  @media (max-width: 960px) {
    margin-bottom: 40px;
  }
`;

const SectionDescription = styled('p')`
  font-size: 18px;
  line-height: 1.6;
  color: #4f4f4f;
  margin-top: 16px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Grid = styled('div')`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 40px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

const Card = styled('div')`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  gap: 16px;
`;

const CardTitle = styled('h3')`
  font-size: 24px;
  font-weight: 700;
  color: #0e1c2b;
  margin: 0;
`;

const CardDescription = styled('p')`
  font-size: 16px;
  line-height: 1.6;
  color: #4f4f4f;
  margin: 0;
  flex: 1;
`;

const DemoLink = styled('a')`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: ${COLORS.PRIMARY};
  font-weight: 600;
  font-size: 16px;
  text-decoration: none;
  transition: opacity 0.2s;
  width: fit-content;

  &:hover {
    opacity: 0.8;
  }
`;

const customerTypes = [
  {
    title: 'Publishers',
    description:
      'Premium publishers that want to maximize revenue from commerce efforts such as content publishers, newsletter, shopping & loyalty.'
  },
  {
    title: 'Brands & Agencies',
    description:
      'Leading brands and agencies looking to execute and scale sponsorship campaigns across our publisher network.'
  },
  {
    title: 'Creator',
    description:
      'Professional creators, agencies, and creator networks looking to command higher brand spend with better data and enterprise-grade affiliate infrastructure.'
  }
];

export const CustomerTypesSection = () => {
  return (
    <>
      <SectionWrapper id="customer-types">
        <SectionHeader>
          <Headline variant="h3" component="h2">
            Turn affiliate data into revenue
          </Headline>
          <SectionDescription>
            Pair intelligent automation with performance analytics to increase
            yield, margin, and brand outcomes. Discover solutions for both
            publishers and brands.
          </SectionDescription>
        </SectionHeader>
        <Grid>
          {customerTypes.map((type) => (
            <Card key={type.title}>
              <Headline variant="h4" component="h3">
                {type.title}
              </Headline>
              <CardDescription>{type.description}</CardDescription>
              <DemoLink href={CALENDAR_LINK} target="_blank">
                Get a Demo <ArrowRight size={18} />
              </DemoLink>
            </Card>
          ))}
        </Grid>
      </SectionWrapper>
    </>
  );
};
